module.exports = __webpack_public_path__ + "static/media/photo125.e9dd5564.jpg";